import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IThreadSouceProperties } from '../conversations_interface';

export class ConversationThread implements IIndexable {
  id: number;
  email_subject: string;
  friendly_sender_name: string;
  email_message: string;
  status: string;
  source_name: string;
  sent_timestamp: string;
  source_properties: IThreadSouceProperties;
  callback_url: string;

  constructor(conversationThread: Partial<ConversationThread>) {
    _4.merge(this, conversationThread);
  }

  static build(conversationThread: Partial<ConversationThread>): ConversationThread {
    return new ConversationThread(conversationThread);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/builders/conversation_thread_builder.ts